import AboutusComponent from "../components/aboutuscomponents/aboutuscomponent"

const AboutusPage =()=>{

    return(
        <AboutusComponent/>
    )
    
}
export default AboutusPage